<template>
  <div
    class="content-box"
    :class="{small, xsmall, xlarge, 'screen-sm': $vuetify.breakpoint.mdAndDown}"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: 'PageContent',
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    xsmall: {
      type: Boolean,
      default: false,
    },
    xlarge: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.content-box {
  // position: absolute;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  // overflow: auto;
  // margin-top: 170px;
  padding: 0 30px;
  margin-top: 12px;
  // &.small {
  //   margin-top: 150px;
  // }

  // &.xsmall {
  //   margin-top: 115px;
  // }

  // &.xlarge {
  //   margin-top: 340px;
  // }

  // &.screen-sm {
  //   position: static;
  //   margin-top: 0;
  // }
}
</style>
